"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5365],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 65365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12261);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const BoxBackground = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  componentId: "sc-3xtrqd-0"
})(["transform:skew(-10deg);background-color:", ";z-index:2;border-radius:10px;width:80%;height:9.438rem;margin:auto auto;@media screen and (min-width:48em){width:30rem;height:12.875rem;}"], props => props.theme.palette.baseWhite);
const LinkBoxWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  componentId: "sc-3xtrqd-1"
})(["position:absolute;top:0;height:12.875rem;width:100%;background-color:transparent;z-index:20;@media screen and (min-width:48em){width:31.5rem;}"]);

const SliderBox = _ref => {
  let {
    image,
    title,
    description,
    action,
    actionMobile,
    href,
    alt
  } = _ref;
  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
    position: "relative",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BoxBackground, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(LinkBoxWrapper, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: {
          base: '1.125rem',
          md: '1.375rem'
        },
        lineHeight: {
          base: '1.463rem',
          md: '1.788rem'
        },
        letterSpacing: "0.6px",
        py: "6",
        pl: {
          base: '18%',
          md: '9'
        },
        pr: {
          base: '18%',
          md: '0'
        },
        textAlign: "left",
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .SimpleGrid */ .MI, {
        gap: "15px",
        w: {
          base: '84%',
          md: '90%'
        },
        h: "90px",
        gridTemplateColumns: {
          base: '1.0fr 0.9fr',
          md: '0.7fr 0.8fr'
        },
        ml: {
          base: '-7px',
          md: '-20px'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
          ml: {
            base: '18px',
            md: '-40px'
          },
          position: "relative",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: image,
            layout: "fill",
            objectFit: "contain",
            placeholder: "empty",
            alt: title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
          display: {
            base: 'inline-block',
            md: 'flex'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
              color: "baseDark",
              fontFamily: "Montserrat-Regular",
              fontSize: "1.125rem",
              textAlign: "left",
              lineHeight: "23px",
              letterSpacing: "0.3px",
              display: {
                base: 'none',
                md: 'block'
              },
              children: description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
              href: href,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: alt,
                action: isMobile && actionMobile ? actionMobile : action,
                textTransform: "uppercase",
                marginTop: {
                  base: '-5px',
                  md: '20px'
                }
              })
            })]
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SliderBox);

/***/ }),

/***/ 12261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["width", "action", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const PrimaryButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_ref, ref) => {
  let {
    width,
    action,
    onClick
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const buttonSize = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)(['md', 'lg']);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, _objectSpread(_objectSpread({
    bg: "primaryGreen.300",
    color: "primaryGreen.900",
    fontFamily: "Montserrat-SemiBold",
    fontWeight: "inherit",
    borderRadius: 4,
    overflow: "hidden",
    width: width || '100%',
    size: buttonSize,
    _active: {
      bg: 'primaryGreen.800',
      color: 'baseWhite'
    },
    _hover: {
      bg: props.disabled ? '' : 'primaryGreen.900',
      color: props.disabled ? '' : 'baseWhite'
    },
    _disabled: {
      bg: 'baseNeutral.200',
      color: 'baseNeutral.400',
      cursor: 'default'
    },
    onClick: onClick
  }, props), {}, {
    children: action
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (PrimaryButton);

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);